import { Routes } from '@angular/router';
import { HomePageComponent } from './modules/dashboard/pages/home-page/home-page.component';
import { PageNotFoundComponent } from './shared/components/page-not-found/page-not-found.component';
import { SystemLayoutComponent } from './core/layout/system-layout/system-layout.component';
import { AuthGuard } from './modules/access-system/guards/auth.guard';

export const routes: Routes = [
  // Rotas de acesso (login/recover-password) - sem layout
  {
    path: '',
    loadChildren: () =>
      import('./modules/access-system/access-system.routes').then(
        (m) => m.ACCESS_SYSTEM_ROUTES,
      ),
  },
  // Rotas protegidas com layout
  {
    path: '',
    component: SystemLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'dashboard',
        component: HomePageComponent,
        canActivate: [AuthGuard],
      },
      {
        path: 'localidades',
        loadChildren: () =>
          import('./modules/unit/unit.routes').then((m) => m.UNIT_ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'tipos-de-unidades',
        loadChildren: () =>
          import('./modules/unit-type/unit-type.routes').then(
            (m) => m.UNIT_TYPE_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'cooperados',
        loadChildren: () =>
          import('./modules/associate/associate.routes').then(
            (m) => m.ASSOCIATE_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'propriedades',
        loadChildren: () =>
          import('./modules/property/property.routes').then(
            (m) => m.PROPERTY_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'tipos-de-estacoes',
        loadChildren: () =>
          import('./modules/stations-type/stations-type.routes').then(
            (m) => m.UNIT_TYPE_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'estacoes',
        loadChildren: () =>
          import('./modules/stations/stations.routes').then(
            (m) => m.STATIONS_ROUTES,
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'pluviometros',
        loadChildren: () =>
          import('./modules/pluviometry/pluviometry.routes').then(
            (m) => m.PLUVIOMETRY_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'pluviometros/dados',
        loadChildren: () =>
          import('./modules/pluviometry-data/pluviometry-data.routes').then(
            (m) => m.PLUVIOMETRY_DATA_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'pluviometros/estimar-temperatura',
        loadComponent: () =>
          import('./modules/pluviometry-data/pages/pluviometry-temperature-estimate/pluviometry-temperature-estimate.component').then(
            (m) => m.PluviometryTemperatureEstimateComponent,
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'balanco-hidrico',
        loadChildren: () =>
          import('./modules/water-balance/water-balance.routes').then(
            (m) => m.waterBalanceRoutes,
          ),
        // Futuramente: Adicionar um AuthGuard aqui para proteger esta rota
        // canActivate: [AuthGuard]
      },

      {
        path: 'floradas',
        loadChildren: () =>
          import('./modules/flowering/flowering.routes').then(
            (m) => m.FLOWERING_ROUTES,
          ),
        canActivate: [AuthGuard],
      },

      {
        path: 'colaboradores',
        loadChildren: () =>
          import('./modules/collaborator/collaborator.routes').then(
            (m) => m.COLLABORATOR_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'viabilidades-economicas',
        loadChildren: () =>
          import('./modules/economic-viability/economic-viability.routes').then(
            (m) => m.ECONOMIC_VIABILITY_ROUTES,
          ),
        canActivate: [AuthGuard],
      },
      {
        path: 'relatorios',
        loadChildren: () =>
          import('./modules/report/report.routes').then((m) => m.REPORT_ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'sad',
        loadChildren: () =>
          import('./modules/sad/sad.routes').then((m) => m.SAD_ROUTES),
        canActivate: [AuthGuard],
      },
      {
        path: 'cultivar',
        loadChildren: () =>
          import('./modules/cultivar/cultivar.routes').then(
            (m) => m.CULTIVAR_ROUTES
          ),
        canActivate: [AuthGuard],
      },

      // Redireciona '' para dashboard, se desejar:
      { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
    ],
  },
  {
    path: '**',
    component: PageNotFoundComponent,
  },
];
